
export default class ReviewsController {

    constructor (
        $filter,
        $state,
        $window,
        $timeout,
        Review,
        Survey,
        brand,
        stores,
        selectedStore,
        endDate,
        startDate,
        reviewsOffset,
        commentsFilter,
        ratingFilter,
        npsFilter,
        reviewsLoader,
        reviews,
        ratingStats,
        npsstats
    ) {
        this.translate     = $filter('translate');
        this.$state        = $state;
        this.$window       = $window;
        this.$timeout      = $timeout;
        this.Review        = Review;
        this.Survey        = Survey;
        this.brand         = brand;
        this.stores        = stores;
        this.selectedStore = selectedStore;
        this.endDate       = endDate;
        this.startDate     = startDate;
        this.reviewsLoader = reviewsLoader;
        this.reviewsPageNumber = (reviewsOffset/20 + 1);
        this.reviewsOffset = reviewsOffset;
        this.reviewsCount = reviews.count;
        this.filter        = {
            comments: commentsFilter,
            ratings:  isNaN(ratingFilter) ? ratingFilter: parseInt(ratingFilter),
            nps:      npsFilter
        };

        this.setReviews(reviews.reviews);
        this.stats   = this.processStats(ratingStats);
        this.npsScoreDoughnutConfig = this.getNpsScoreDoughnutConfig(npsstats);
        this.npsCount = npsstats.count;
    }

    setComments (type) {
        this.filter.comments = type;
        this.updateFilters();
    }


    setRatings (type) {
        this.filter.ratings = type;
        this.updateFilters();
    }

    setNps (type) {
        this.filter.nps = type;
        this.updateFilters();
    }

    updateFilters () {
        this.reviewsOffset = 0;
        this.reviewsPageNumber = 1;
        
        this.getMoreReviews();
    }

    changePage() {
        this.reviewsOffset = 20*(this.reviewsPageNumber-1);
        this.getMoreReviews();
    }

    getMoreReviews() {       
        this.$state.transitionTo(this.$state.current.name, {
            stores:    (this.selectedStore) ? this.selectedStore.id : undefined,
            startDate: (this.startDate) ? this.startDate : undefined,
            endDate:   (this.endDate) ? this.endDate : undefined,
            reviewsOffset: this.reviewsOffset,
            commentsFilter: this.filter.comments,
            ratingFilter: this.filter.ratings,
            npsFilter: this.filter.nps
        }, {reload: false});
    }

    reply (review) {
        swal({
            title: this.translate('REPLY_TO_COMMENT'),
            type: 'input',
            html: true,
            showCancelButton: true,
            closeOnConfirm: false,
        }, response => {
            if (response === false) {
                return false;
            }

            if (response === "") {
                swal.showInputError("You need to write something!");
                return false
            }

            return this.Review.reply(
                review.RatingId,
                response
            ).then(_ => this.reviewsLoader().then(reviews => this.$timeout(_ => {
                this.setReviews(reviews.reviews);
                swal.close();
            })));
        });
    }

    setReviews (reviews) {
        this.filteredReviews = reviews;
    }

    processStats (ratings) {
        return ratings.filter(rating => parseInt(rating.value) > 0 && parseInt(rating.value) < 6).reduce((stats, rating) => {
            return {
                total:  stats.total  + rating.value,
                count:  stats.count  + 1,
                count1: stats.count1 + (rating.value === 1 ? 1 : 0),
                count2: stats.count2 + (rating.value === 2 ? 1 : 0),
                count3: stats.count3 + (rating.value === 3 ? 1 : 0),
                count4: stats.count4 + (rating.value === 4 ? 1 : 0),
                count5: stats.count5 + (rating.value === 5 ? 1 : 0),
            };
        }, { total: 0, count: 0, count1: 0, count2: 0, count3: 0, count4: 0, count5: 0 });
    }

    openReceipt (review) {
        swal({
            title: '',
            text: '<iframe'
                 +' style="display: block; border: 0; width: 100%; height: 60vh;"'
                 +' src="https://web.mangooid.com/pdf-viewer.html?link='+encodeURIComponent(review.receiptUrl)+'"'
                 +'></iframe>',
            html: true,
        });
    }

    openSurvey (review) {
        this.Survey.getResponses(review.surveyId, review.id)
            .then(elements => {
                const content =
                      '<div style="max-height: calc(100vh - 200px); overflow: auto;">'
                    + elements
                        .filter(el => el.answer != null && el.answer != '')
                        .map(el => '<b>' + el.elementText + '</b><br />' + el.answer + '<br />')
                        .join('')
                    + '</div>';
                swal({
                    title: '',
                    text:  content,
                    html:  true,
                });
            })
    }

    getNpsScoreDoughnutConfig(npsstats) {
        return ({
            data: {
                labels: [
                    'Promoters',
                    'Passives',
                    'Detractors'
                ],
                datasets: [{
                    data: [npsstats.promoters, npsstats.passives, npsstats.detractors],
                    backgroundColor: [
                        "#35CE7D",
                        "#0CAFD1",
                        "#F2624F"
                    ],
                    hoverBackgroundColor: [
                        "#35CE8D",
                        "#0CAFE1",
                        "#F2625F"
                    ]
                }]
            },
            text: npsstats.score
        });
    }

}

ReviewsController.$inject = [
    '$filter',
    '$state',
    '$window',
    '$timeout',
    'Review',
    'Survey',
    'brand',
    'stores',
    'selectedStore',
    'endDate',
    'startDate',
    'reviewsOffset',
    'commentsFilter',
    'ratingFilter',
    'npsFilter',
    'reviewsLoader',
    'reviews',
    'ratingStats',
    'npsstats'
];



// WEBPACK FOOTER //
// ./src/page/reviews/reviews.controller.js